<template>
  <div
    :class="['tris-scroll-good', type === 'scroll' ? 'scroll' : '']"
    @click="goDetail"
  >
    <good-image
      :img-url="sku.skuImg.imgUrl"
      :image-width="goodWidth"
      :promote-tag-pic="promoteTagPic"
      :stock-status="stockStatus"
      :is-video="isVideo"
      :sku-img="skuImg"
    />
    <div class="tris-scroll-info">
      <div class="good-tag-wrap">
        <good-tag :good-tags="goodTags" />
      </div>
      <base-info
        :custom-style="baseInfoStyle"
        :name="sku.skuBase.skuName"
        :format-info="formatInfo"
      />

      <good-price
        total-price-placeholder
        :ssu="sku"
        :ssu-info="ssuInfo"
        :custom-style="customPriceStyle"
        :show-original-price="false"
        :show-member-price="false"
        :custom-operator="customOperator"
        :from-page="fromPage"
        :show-discount-price="true"
        :show-mult-original-price="showOriginalPrice"
        :is-hint="sku.promise.isHintNoArriveAm"
        @goDetail="goDetail"
      />
    </div>
  </div>
</template>

<script>
import mixin from '../mixin'

export default {
  name: 'SoleGood',
  mixins: [mixin],
  data() {
    return {
      baseInfoStyle: {
        root: {
          // height: '0.74rem'
        },
        name: {
          fontSize: '0.24rem',
          height: '0.72rem',
          display: '-webkit-box',
          '-webkit-box-orient': 'vertical',
          '-webkit-line-clamp': 2,
          'white-space': 'initial'
        },
        format: {
          fontSize: '0.22rem'
        }
      }
    }
  },
  computed: {
    customPriceStyle() {
      return {
        root: {
          marginTop: '0'
        },
        totalPrice: {
          fontSize: this.type === 'scroll' ? '0.28rem' : '0.3rem'
        }
      }
    },
    customOperator() {
      return {
        simple: false,
        showPromoteTip: false,
        type: 'large',
        btnWith: this.type === 'scroll' ? 1.6 : 1.92
      }
    }
  }
}
</script>

<style lang="scss">
.tris-scroll-good {
  // transform: translate3d(0, 0, 0);

  overflow: hidden;

  background-color: #fff;
  border-radius: 0.16rem;

  flex: none;
  box-sizing: border-box;
  @include flex(column, flex-start, flex-start, nowrap);

  &.scroll {
    // height: 4.4rem;
  }
}
.tris-scroll-info {
  position: relative;

  width: 100%;
  box-sizing: border-box;

  padding: 0 0.16rem 0.12rem 0.16rem;

  overflow: hidden;

  flex: auto;

  .good-tag-wrap {
    margin-top: 0.04rem;
  }
}
</style>
